<div class="wmrp-container">

  @if (conditionsForm) {
    <div class="wmrp-conditions" [formGroup]="conditionsForm"
      [style.height.px]="conditionsHeight">
      <table class="table text-start">
        <thead>
          <tr>
            <th class="chkbox">
              @if (editable) {
                <div class="form-check form-check-inline">
                  <input type="checkbox" value="true" class="form-check-input" formControlName="checkAll"
                    (change)="toggleAll()">
                  <input type="hidden" formControlName="paramsSetId">
                </div>
              }
            </th>
            <th class="title">Module</th>
            <th class="desc">Input Description</th>
            <th>Conditions</th>
          </tr>
        </thead>
        <tbody formArrayName="conditions">
          @for (ctrl of conditionsFA.controls; track ctrl; let i = $index) {
            <tr>
              <ng-container [formGroupName]="i">
                <td>
                  <div class="form-check form-check-inline">
                    <input type="checkbox" value="true" class="form-check-input" formControlName="chkbox"
                      (change)="chkboxChange(i)" [attr.disabled]="getEditable()">
                  </div>
                </td>
                <td>{{wmrpMod[i].title}}
                  <input type="hidden" formControlName="moduleId">
                  <input type="hidden" formControlName="breakType">
                </td>
                <td>{{wmrpMod[i].breakDescription}}</td>
                <td class="condition-input" formArrayName="conds-input">
                  <div class="row mx-0">
                    @for (inp of conditionsFA.at(i).get('conds-input').controls; track inp; let x = $index) {
                      <button type="button" class="condition-item" (click)="addInput(i, inp, x)"
                        [class.d-none]="(conditionsFA.at(i).get('conds-input').controls.length === 1 && wmrpMod[i].breakType === 1)">
                        <div class="d-flex">
                          @if ((conditionsFA.at(i).get('conds-input').controls.length > 1 && wmrpMod[i].breakType === 1) || wmrpMod[i].breakType === 0) {
                            <ng-container [formGroupName]="x"
                              >
                              <input type="hidden" formControlName="alias">
                              <span class="fc" [class.d-none]="hideCtrl(i, x, 'alias')"
                                [style.width.px]="calculateWidth(i, x, 'alias')">
                              {{conditionsFA.at(i).get('conds-input').at(x).get('alias').value}}</span>
                              @if (!isAliasBlank(i, x)) {
                                <span class="brackets">(</span>
                              }
                              @if (wmrpMod[i].breakType === 1 && conditionsFA.at(i).get('conds-input').controls.length !== x + 1) {
                                <span
                                >≤</span>
                              }
                              <input type="hidden" formControlName="breakValue">
                              <span class="fc" [style.width.px]="calculateWidth(i, x, 'breakValue')"
                                [class.text-center]="wmrpMod[i].breakType === 1 && !isLastCondition(i, x)">
                              {{conditionsFA.at(i).get('conds-input').at(x).get('breakValue').value}}</span>
                              @if (!isAliasBlank(i, x)) {
                                <span class="brackets">)</span>
                              }
                              <input type="hidden" formControlName="analysisValue">
                              <span class="fc-sm text-center d-block"
                                [style.width.px]="calculateWidth(i, x, 'analysisValue')">
                              {{conditionsFA.at(i).get('conds-input').at(x).get('analysisValue').value}}</span>
                            </ng-container>
                          }
                        </div>
                      </button>
                    }
                    @if (editable) {
                      <div class='btn-add-wrapper'>
                        <button class="btn btn-link p-0 ml-2 btn-add" (click)="addInput(i)"
                          [attr.disabled]="getCondsCount(i)"><i
                        class="fa-regular fa-circle-plus fa-lg"></i></button>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
      <!-- {{currentConditions | json}} -->
    </div>
  }
  @if (editable) {
    <div class="btn-container row m-0 run" [class.justify-content-between]="!enableRun()"
      [class.justify-content-end]="enableRun()">
      @if (!enableRun()) {
        <div class="text-danger pl-2">
          {{errorMsg}}
        </div>
      }
      @if (isWMRPUser) {
        <button type="button" class="btn btn-primary btn-next btn-run-analysis" (click)="runAnalysis()"
        [attr.disabled]="enableRun() === false ? true : null">Run Analysis</button>
      }
    </div>
  }
  @if (!editable) {
    <div class="save-template-container mt-2 mr-2 d-flex justify-content-end">
      @if (showTemplateForm) {
        <div class="form-container mr-2 form-group mb-0" [formGroup]="templateForm">
          <input type="text" formControlName="templateName" class="form-control mb-0" placeholder="Template Name">
        </div>
      }
      @if (!showTemplateForm) {
        <button type="button" class="btn btn-primary mr-2" (click)="exportParams()"><i
        class="fa-solid fa-file-export"></i> Export</button>
      }
      @if (!showTemplateForm && isWMRPUser) {
        <button type="button" class="btn btn-primary"
          (click)="showTemplateForm = true"><i class="fa-regular fa-floppy-disk"></i> Save Template</button>
        }
        @if (showTemplateForm) {
          <button type="button" class="btn btn-primary btn-save"
            (click)="saveParamsToTemplate()"><i class="fa-regular fa-floppy-disk"></i>
          Save</button>
        }
        @if (showTemplateForm) {
          <button type="button" class="btn btn-outline-primary ml-2"
            (click)="showTemplateForm = false">
          Cancel</button>
        }
      </div>
    }
  </div>

  <ng-template #condition let-modal>
    <div class="modal-header">
      <h4>{{wmrpMod[currentParameterIndex].title}} Condition</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"><i
      class="fa-solid fa-xmark"></i></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="inputForm">
        @if (breakType === 'number') {
          <div>
            <div class="row mx-0 my-3">
              <div class="col-6 pl-1">
                <label>Condition</label>
                <div class="input-group mb-3">
                  <span>{{isLastCondition(currentParameterIndex, currentConditionIndex) &&
                    this.currentConditionIndex !== -1 ? '>' :
                  '≤'}}</span>
                  <input type="text" class="form-control" formControlName="conditionValue"
                    [attr.disabled]="isLastCondition(currentParameterIndex, currentConditionIndex) === true && this.currentConditionIndex !== -1 ? true : null"
                    required>
                  @if (inputForm.get('conditionValue').hasError('duplicate')) {
                    <div
                      class="text-danger ml-3 mt-2 small">
                      Break value has already been used
                    </div>
                  }
                  @if (inputForm.get('conditionValue').hasError('pattern')) {
                    <div
                      class="text-danger ml-3 mt-2 small">
                      Please enter a number
                    </div>
                  }
                  @if (inputForm.get('conditionValue').hasError('required') && inputForm.get('conditionValue').touched) {
                    <div
                      class="text-danger ml-3 mt-2 small">
                      This field is required
                    </div>
                  }
                </div>
              </div>
              <div class="col-6">
                <label>Value</label>
                <input type="number" class="form-control" formControlName="numValue" required>
                @if (inputForm.get('numValue').hasError('required') && inputForm.get('numValue').touched) {
                  <div
                    class="text-danger mt-2 small">
                    This field is required
                  </div>
                }
              </div>
            </div>
            <div class="row mx-0 my-3 d-block">
              <div class="col-12 pl-1">
                <label class="form-label">Alias (optional)</label>
                <input type="text" class="form-control" formControlName="alias">
              </div>
            </div>
          </div>
        }
        @if (breakType === 'string') {
          <div>
            <div class="row d-block mx-0">
              <label class="form-label">Materials</label>
              <ng-select [clearable]="false" [searchable]="false" formControlName="materials" [multiple]="true"
                [closeOnSelect]="false" [appendTo]="body" [items]="materials" bindLabel="name" bindValue="code" class="materials-dd"
                required>
              </ng-select>
              @if (inputForm.get('materials').hasError('required') && inputForm.get('materials').touched) {
                <div
                  class="text-danger mt-2 small">
                  This field is required
                </div>
              }
            </div>
            <div class="row mx-0 mt-3">
              <div class="col">
                <label>Value</label>
                <input type="number" class="form-control sm mx-0" formControlName="numValue" required>
                @if (inputForm.get('numValue').hasError('required') && inputForm.get('numValue').touched) {
                  <div
                    class="text-danger mt-2 small">
                    This field is required
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </form>
    </div>
    <div class="modal-footer">
      <!-- {{currentParameterIndex}} | {{currentConditionIndex}} -->
      <div class="row w-100 m-0">
        <div class="col-6 pl-1">@if (canDelete(currentParameterIndex, currentConditionIndex)) {
          <button
            type="button" class="btn btn-danger btn-icon" (click)="deleteCondition()" title="Delete"><i
          class="fa-regular fa-trash"></i></button>
        }
      </div>
      <div class="col-6 d-flex justify-content-end btns pr-1"> <button type="button"
      class="btn btn-outline-primary" (click)="dismissModal()" title="Cancel">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveCondition()"
                    [disabled]="inputForm.untouched || inputForm.invalid" title="{{currentConditionIndex > -1 ? 'Update' :
                    'Add'}}">{{currentConditionIndex > -1 ? 'Update' :
      'Add'}}</button>
    </div>
  </div>


</div>
</ng-template>